import React from "react";
import About from "../components/About";
import Courses from "../components/Courses";
import FAQ from "../components/FAQ";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";

const Homepage = () => {
  return (
    <motion.div
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <About />
      <Courses />
      <FAQ />
      <ScrollTop />
    </motion.div>
  );
};

export default Homepage;
